import { Phone, Mail, MapPin } from "lucide-react";
import { Logo } from "@/components/Logo";

export default function Footer() {
  return (
    <footer className="bg-[#083B4F] py-14 text-cream">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 sm:px-6 md:grid-cols-3 lg:px-8">
        <div>
          <Logo dark />
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-cream/60">
            Livraison indépendante de proximité à Illzach : drives, colis, fleurs et courses sur mesure, d'un point
            A à un point B, pour tous ceux qui ne peuvent pas se déplacer.
          </p>
        </div>
        <div>
          <h3 className="mb-4 text-sm font-semibold uppercase tracking-[0.18em] text-cream/50">Contact</h3>
          <ul className="space-y-3 text-sm">
            <li>
              <a href="tel:+33673318236" className="flex items-center gap-2 text-cream/80 transition-colors hover:text-terra">
                <Phone className="h-4 w-4" /> 06 73 31 82 36
              </a>
            </li>
            <li>
              <a href="mailto:angelivraisons@gmail.com" className="flex items-center gap-2 text-cream/80 transition-colors hover:text-terra">
                <Mail className="h-4 w-4" /> angelivraisons@gmail.com
              </a>
            </li>
            <li className="flex items-center gap-2 text-cream/80">
              <MapPin className="h-4 w-4" /> Illzach et alentours — rayon de 20 km
            </li>
            <li className="text-cream/60">Lun–Ven : 8h–17h · Sam : 8h–16h · Dim & jours fériés : fermé</li>
          </ul>
        </div>
        <div>
          <h3 className="mb-4 text-sm font-semibold uppercase tracking-[0.18em] text-cream/50">Informations</h3>
          <ul className="space-y-3 text-sm text-cream/60">
            <li>Angélivraisons — SIRET 130 826 621 00018</li>
            <li>Commandes groupées : zone élargie possible</li>
            <li>
              <a href="/suivi" data-testid="footer-tracking-link" className="underline-offset-4 transition-colors hover:text-terra hover:underline">
                Suivre ma livraison
              </a>
            </li>
            <li>
              <a href="/admin" data-testid="footer-admin-link" className="underline-offset-4 transition-colors hover:text-terra hover:underline">
                Espace pro
              </a>
            </li>
          </ul>
        </div>
      </div>
      <p className="mt-12 text-center text-xs text-cream/40">© 2026 Angélivraisons — Livré avec le cœur.</p>
    </footer>
  );
}
